module.exports = __webpack_public_path__ + "static/media/users.053591a2.svg";